import { useEffect, useState } from 'react';
import { onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';
import { foodMenuCollection } from '../../services/foodOrderService';
export default function useFoodMenu(hotelId, enabled = true) {
  const [state, setState] = useState({
    hotelId: '',
    items: [],
    loading: true,
    error: ''
  });
  useEffect(() => {
    if (!hotelId || !enabled) return undefined;
    setState({
      hotelId,
      items: [],
      loading: true,
      error: ''
    });
    return onSnapshot(foodMenuCollection(db, hotelId), snapshot => setState({
      hotelId,
      items: snapshot.docs.map(item => ({
        ...item.data(),
        id: item.id
      })).sort((a, b) => a.category.localeCompare(b.category) || a.name.localeCompare(b.name)),
      loading: false,
      error: ''
    }), error => setState({
      hotelId,
      items: [],
      loading: false,
      error: error.message
    }));
  }, [hotelId, enabled]);
  return state.hotelId === hotelId && enabled ? state : {
    items: [],
    loading: true,
    error: ''
  };
}
